import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageSituationPageCompletedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageSituationPageCompletedEventTracking';

export class StandardTriageRecommendationPageEventTracking extends StandardTriageSituationPageCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.VIEWED_STANDARD_TRIAGE_RECOMMENDATION_PAGE;
  recommended_product?: string;

  constructor(eventProperties: Partial<StandardTriageRecommendationPageEventTracking> = {}) {
    super(eventProperties);
    this.recommended_product = eventProperties?.recommended_product;
  }
}
